import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import BaggageDetail from './BaggageDetail';
import * as baggageActions from './../../../../../actions/baggageAction';

const mapStateToProps = state => {
    return {
        baggageState: state.baggageReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getBaggageDetail: (id) => dispatch(baggageActions.getBaggageDetail(id)),
        setBaggageDetail: (baggage) => dispatch(baggageActions.setBaggageDetail(baggage)),
        updateBaggageDetail: (baggage) => dispatch(baggageActions.updateBaggageDetail(baggage)),
        createBaggageDetail: (baggage) => dispatch(baggageActions.createBaggageDetail(baggage))
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(BaggageDetail));
